<ng-container *ngIf="mainAppService?.mainApp">
  <div class="container">
    <div  class="member-form"> 
      <div style="text-align: center; padding: 4px;">
        <img width="48" alt="Zulu logo" src="/assets/images/logo.jpg"  (click)="goHome()" />
      </div>
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.name}}</mat-label>
        <input matInput [(ngModel)]="member.name" type="text">
      </mat-form-field>
      
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.lastName}}</mat-label>
        <input matInput [(ngModel)]="member.lastName" type="text">
      </mat-form-field>
      
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.country}}</mat-label>
        <mat-select [(value)]="selectedCountry">
          <mat-option *ngFor="let country of countries" [value]="country">
            {{country.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <div class="member-full-width-alink">
        <mat-radio-group   [(ngModel)]="selectedSex">
          <mat-radio-button value="M" style="margin: 8px 22px;">{{mainAppService.mainApp.male}}</mat-radio-button>
          <mat-radio-button value="F" style="margin: 8px 22px;">{{mainAppService.mainApp.female}}</mat-radio-button>
        </mat-radio-group>
    
      </div>
  
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.age}}</mat-label>
        <input matInput [(ngModel)]="member.age" type="number">
      </mat-form-field>
  
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.email}}</mat-label>
        <input matInput [(ngModel)]="member.email" type="email">
      </mat-form-field>
  
      <!-- <div class="member-full-width-alink">
        <mat-checkbox class="example-margin" [(ngModel)]="member.hasJumpedBefore">{{mainAppService.mainApp.hasJumpedBefore}}</mat-checkbox>  
      </div> -->
  
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.source}}</mat-label>
        <mat-select [(value)]="member.sourceId">
          <mat-option *ngFor="let source of mainAppService.mainApp.sources" [value]="source.sourceId">
            {{source.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
 
      <!-- <div class="instructions">
        <h2>{{mainAppService.mainApp.instructionsHeader}}</h2>
        {{mainAppService.mainApp.instructions}}
      </div>
  
      <div class="instructions">
        <h2>{{mainAppService.mainApp.confirmHeader}}</h2>
        {{mainAppService.mainApp.confirmText}}
      </div> -->
  
      <mat-form-field class="member-full-width">
        <mat-label>{{mainAppService.mainApp.idPassport}}</mat-label>
        <input matInput [(ngModel)]="member.idPassport" type="text">
      </mat-form-field>

      <div>
        <h2>
          {{mainAppService.mainApp.signatureHeader}}
        </h2>
        <app-draw-surface></app-draw-surface>
      </div>
      
      <div class="member-full-width-alink">
        <mat-checkbox class="example-margin" [(ngModel)]="member.agreedOnTerms"></mat-checkbox><a (click)="showTermsDialog();" class="alink">{{mainAppService.mainApp.termsHeader}}</a>
      </div>
      <div class="member-full-width-alink">
        <mat-checkbox class="example-margin" [(ngModel)]="member.agreedOnGDPR"> </mat-checkbox><a (click)="showGDPRDialog();" class="alink">{{mainAppService.mainApp.gdprHeader}}</a>
      </div>
  
      <button mat-raised-button color="primary" style="width: 220px; height: 48px; margin-top: 22px;" (click)="register()"  [disabled]="!member.agreedOnGDPR || !member.agreedOnTerms || !member.name || !member.lastName || !member.age || !member.email || !selectedSex || !member.sourceId  || !selectedCountry">Submit</button>
    </div>
  </div>
</ng-container>